// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"30":"0c197784","389":"0c197784","595":"0c197784","909":"0c197784","943":"0c197784"}[chunkId] + ".chunk.css";
};